import { createStore } from 'vuex'

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    marcas: null,
    sliders: null,
    featureds: null,
    mainmenu: false,
    mainmenuItems: null,
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    updateMarca(state, value) {
      state.marcas = value
    },
    updateSliders(state, value) {
      state.sliders = value
    },
    updateFeatureds(state, value) {
      state.featureds = value
    },
    updateMainmenu(state, value) {
      state.mainmenu = value
    },
    updateMainmenuItems(state, value) {
      state.mainmenuItems = value
    },
  },
  actions: {},
  modules: {},
})
